'use strict';
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
      global.i18nlink = factory()
}(this, function () {
  var i18nLinks = {
    url_paths: {
      // Terms of Use is deprecated
      // Terms & Conditions
      term: {
        de: 'unternehmen/agb',
        es: 'empresa/condiciones-de-uso/web',
        es_mx: 'compania/condiciones-de-uso/web',
        fr: 'conditions-generales-d-utilisation',
        fr_ca: 'conditions-generales-d-utilisation',
        ja: 'company/terms-and-conditions/web',
        pt_br: 'termos-e-condicoes',
        pt: 'termos-e-condicoes',
        en_au: 'company/terms-and-conditions/web',
        en_gb: 'company/terms-and-conditions/web',
        en_ca: 'company/terms-and-conditions/web',
        _: 'company/terms-and-conditions/web',
      },
      // Terms of Use is deprecated but
      // iframe Terms & Conditions is not ready yet
      iterm: {
        de: 'iframe/unternehmen/agb',
        es: 'iframe/empresa/condiciones-de-uso/web',
        es_mx: 'iframe/compania/condiciones-de-uso/web',
        fr: 'iframe/conditions-generales-d-utilisation',
        fr_ca: 'iframe/conditions-generales-d-utilisation',
        ja: 'iframe/company/terms-and-conditions/web',
        pt_br: 'iframe/termos-e-condicoes',
        pt: 'iframe/termos-e-condicoes',
        en_au: 'iframe/company/terms-and-conditions/web',
        en_gb: 'iframe/company/terms-and-conditions/web',
        en_ca: 'iframe/company/terms-and-conditions/web',
        _: 'iframe/company/terms-of-use',
      },
      privacy: {
        de: 'unternehmen/datenschutz',
        es: 'empresa/pol%C3%ADtica-de-privacidad',
        es_mx: 'compania/politica-de-privacidad',
        fr: 'societe/politique-de-confidentialite',
        fr_ca: 'societe/politique-de-confidentialite',
        ja: 'company/privacy-policy',
        pt_br: 'politica-de-privacidade',
        pt: 'politica-de-privacidade',
        en_au: 'company/privacy-policy',
        en_gb: 'company/privacy-policy',
        en_ca: 'company/privacy-policy',
        _: 'company/privacy-policy'
      },
      iprivacy: {
        de: 'iframe/unternehmen/datenschutz',
        es: 'iframe/empresa/pol%C3%ADtica-de-privacidad',
        es_mx: 'iframe/compania/politica-de-privacidad',
        fr: 'iframe/societe/politique-de-confidentialite',
        fr_ca: 'iframe/societe/politique-de-confidentialite',
        ja: 'iframe/company/privacy-policy',
        pt_br: 'iframe/politica-de-privacidade',
        pt: 'iframe/politica-de-privacidade',
        en_au: 'iframe/company/privacy-policy',
        en_gb: 'iframe/company/privacy-policy',
        en_ca: 'iframe/company/privacy-policy',
        _: 'iframe/company/privacy-policy'
      },
      ip: {
        de: 'unternehmen/geistiges_eigentum',
        fr: 'IP',
        fr_ca: 'IP',
        en_au: 'IP',
        en_gb: 'IP',
        en_ca: 'IP',
        _: 'IP'
      },
      iip: {
        fr: 'iframe/ip',
        fr_ca: 'iframe/ip',
        en_au: 'iframe/ip',
        en_gb: 'iframe/ip',
        en_ca: 'iframe/ip',
        _: 'iframe/IP'
      },
      ariadnext_aes: {
        fr: 'sites/default/files/gtu_fr-aes.pdf',
        fr_ca: 'sites/default/files/gtu_fr-aes.pdf',
        _: 'conditions-generales-d-utilisation/GTU-ID-Check-for-AES-EN'
      },
      ariadnext_qes: {
        fr: 'sites/default/files/gtu_fr-qes.pdf',
        fr_ca: 'sites/default/files/gtu_fr-qes.pdf',
        _: 'conditions-generales-d-utilisation/GTU-ID-Check-In-Person-for-QES-EN'
      },
      idv_eu_adv: {
        fr: 'conditions-generales-d-utilisation/GTU-EU-Advanced-with-IDV-FR',
        fr_ca: 'conditions-generales-d-utilisation/GTU-EU-Advanced-with-IDV-FR',
        _: 'conditions-generales-d-utilisation/GTU-EU-Advanced-with-IDV-EN'
      }
    },
    radmin_new_doc_to_guide_map: {
      'api-keys': 'api-and-keys',
      'audit-logs': 'account-audit-logs',
      'billing-usage': 'billing-and-usage-information',
      'branding-admin': 'configure-branding',
      'comments': 'comments-settings',
      'custom-fields-admin': 'custom-fields',
      'remind-expire-defaults': 'reminders-and-expirations',
      'welcome-admin': 'welcome-to-administration',
    },
    replace_language_to: {
      _: {
        'de': 'de',
        'fr': 'fr',
        'fr_ca': 'fr',
        'ja': 'jp',
        'pt_br': 'br',
        'pt': 'br',
        'en_au': 'en',
        'en_gb': 'en',
        'en_ca': 'en',
        '_': 'en'
      },
      idnow: {
        'de': '6',
        'es': '16',
        'fr': '11',
        'fr_ca': '11',
        'it': '21',
        '_': '1'
      }
    },
    to_be_localized_pages: [
      {
        base_url: 'https://support.docusign.com/',
        url_paths: [
          'login?from=/en/guides/ndse-admin-guide',
          'login?from=/en/guides/ndse-user-guide',
          'en/guides/ndse-admin-guide',
          'en/guides/org-admin-guide',
          'en/guides/ndse-user-guide',
          'en/contactSupport',
          'en/knowledgeSearch',
          'en/articles/'
        ],
        regex: /\/en\//,
        replacement: '/{lang}/',
        languages: '_'
      },
      {
        base_url: 'https://support.docusign.com/',
        url_paths: [
          'login?from=/guides/ndse-admin-guide',
          'login?from=/guides/ndse-user-guide',
          'guides/ndse-admin-guide',
          'guides/ndse-user-guide'
        ],
        regex: /\/guides\//,
        replacement: '/{lang}/guides/',
        languages: '_'
      },
      {
        base_url: 'https://support.docusign.com/',
        url_paths: [
          'releasenotes'
        ],
        regex: /\/releasenotes/,
        replacement: '/{lang}/releasenotes',
        languages: '_'
      },
      {
        base_url: 'https://ps-ws.dsf.docusign.net/',
        url_paths: [
          'ds-server/psm/resources/psm-idnow/idnow_3XIDNDS/pdf/GTU.pdf#page='
        ],
        regex: /page=[0-9]+/,
        replacement: 'page={lang}',
        languages: 'idnow'
      }
    ],
    localized_license_pages: [
      {
        base_url: 'https://www.docusign.com/',
        url_paths: {
          'company/terms-and-conditions/web': 'term',
          'company/terms-of-use': 'term',
          'company/privacy-policy': 'privacy',
          'IP': 'ip',
          'iframe/company/terms-of-use': 'iterm',
          'iframe/company/privacy-policy': 'iprivacy',
          'iframe/IP': 'iip'
        }
      },
      {
        base_url: 'https://www.docusign.fr/',
        url_paths: {
          'conditions-generales-d-utilisation/GTU-ID-Check-for-AES-EN': 'ariadnext_aes',
          'conditions-generales-d-utilisation/GTU-ID-Check-In-Person-for-QES-EN': 'ariadnext_qes',
          'conditions-generales-d-utilisation/GTU-EU-Advanced-with-IDV-EN': 'idv_eu_adv'
        }
      },
    ],
    countryToLanguage: {
      au: 'en_au',
      bg: 'bg',
      br: 'pt_br',
      ca: 'en_ca',
      cn: 'zh_cn',
      cz: 'cs',
      dk: 'da',
      de: 'de',
      gb: 'en_gb',
      gr: 'el',
      us: 'en',
      es: 'es',
      ee: 'et',
      ir: 'fa',
      fi: 'fi',
      fr: 'fr',
      il: 'he',
      'in': 'hi',
      hr: 'hr',
      hu: 'hu',
      id: 'id',
      it: 'it',
      jp: 'ja',
      kr: 'ko',
      lt: 'lt',
      lv: 'lv',
      my: 'ms',
      mx: 'es_mx',
      no: 'nb',
      nl: 'nl',
      pl: 'pl',
      pt: 'pt',
      ro: 'ro',
      ru: 'ru',
      sk: 'sk',
      si: 'sl',
      se: 'sv',
      th: 'th',
      tr: 'tr',
      tw: 'zh_cn',
      ua: 'uk',
      vn: 'vi'
    },
    baseURL_keys: {
      ariadnext_aes: 'fr',
      ariadnext_qes: 'fr',
      idv_eu_adv: 'fr'
    },
    baseURLs: {
      idnow: 'https://ps-ws.dsf.docusign.net/',
      support: 'https://support.docusign.com/',
      de: 'https://www.docusign.de/',
      es: 'https://www.docusign.com.es/',
      es_mx: 'https://www.docusign.mx/',
      fr: 'https://www.docusign.fr/',
      fr_ca: 'https://www.docusign.fr/',
      ja: 'https://www.docusign.jp/',
      pt_br: 'https://www.docusign.com.br/',
      pt: 'https://www.docusign.com.br/',
      en_au: 'https://www.docusign.com.au/',
      en_gb: 'https://www.docusign.co.uk/',
      en_ca: 'https://www.docusign.ca/',
      _: 'https://www.docusign.com/'
    }
  };
  return i18nLinks;
}));
